import { FunctionComponent, memo, useContext, useMemo } from "react";
import { IProps } from "./phrase-triggers-total-interactions-tagged.types";
import useInteractionsCounts from "hooks-for/interactions/use-interactions-counts";
import { NumericValue } from "@edgetier/client-components";
import { PhraseTriggerContext } from "components-for/phrase-triggers/phrase-trigger-context/phrase-trigger-context";
import { PHRASE_TRIGGER_GROUP } from "../../phrase-triggers.constants";
import "./phrase-triggers-total-interactions-tagged.scss";

/**
 * Display total number of interaction tagged from phrase triggers, either per day or per trigger
 * @param props.tagId  Current tag Id passed
 */
const PhraseTriggersTotalInteractionsTagged: FunctionComponent<IProps> = ({ tagId }) => {
    const { filters } = useContext(PhraseTriggerContext);

    // Get counts of phrases or interactions according to the parameters.
    const { data: filteredData, isLoading: isFilteredDataLoading } = useInteractionsCounts({
        startDateTime: filters.startDateTime,
        endDateTime: filters.endDateTime,
        tagId: [tagId],
        groupBy: [filters.groupBy, PHRASE_TRIGGER_GROUP],
    });

    // Total interactions tagged
    const totalInteractionsTagged = useMemo(
        () => (filteredData ?? []).reduce((sum, currentTrigger) => (sum += currentTrigger.count), 0),
        [filteredData]
    );

    return (
        <>
            {!isFilteredDataLoading && (
                <>
                    (<NumericValue value={totalInteractionsTagged} />)
                </>
            )}
        </>
    );
};

export default memo(PhraseTriggersTotalInteractionsTagged);
